// src/redux/carApi.js
import { apiSlice } from "./apiSlice";

export const adminCarApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        postCarAdmin: build.mutation({
            query: (body) => ({
                url: "/api/admin/car/v1",
                method: "post",
                data: body,
                headers: { token: true },
            }),
        }),
        putCarAdmin: build.mutation({
            query: ({ carId, body }) => ({
                url: `/api/admin/car/v1/${carId}`,
                method: "put",
                data: body,
                headers: { token: true },
            }),
        }),
        searchCarAdmin: build.query({
            query: ({ car_number, owner_name }) => ({
                url: "/api/admin/car/v1/search",
                method: "get",
                params: { car_number, owner_name },
                headers: { token: true },
            }),
        }),
        searchCarByNumberAdmin: build.query({
            query: ({ car_number }) => ({
                url: "/api/admin/car/v1/car_number",
                method: "get",
                params: { car_number },
                headers: { token: true },
            }),
        }),
        getAllCarsAdmin: build.query({
            query: (params) => ({
                url: "/api/admin/car/v1",
                method: "get",
                params,
                headers: { token: true },
            }),
        }),

        // 1) 차량 상세조회 (GET /api/user/car/v1/{carId})
        getCarByIdAdmin: build.query({
            query: (carId) => ({
                url: `/api/admin/car/v1/${carId}`,
                method: "get",
                headers: { token: true },
            }),
        }),

        // 2) 차량 대량 등록 (POST /api/user/car/v1/rent_corp/{rentCorpId}/bulk)
        postCarBulkFileAdmin: build.mutation({
            query: ({ rentCorpId, body }) => ({
                url: `/api/admin/car/v1/rent_corp/${rentCorpId}/bulk`,
                method: "post",
                data: body, // FormData 안에 excel_file, zip_file
                headers: { token: true, "Content-Type": "multipart/form-data" },
            }),
        }),

        // 3) 차량 대량 업로드 (POST /api/user/car/v1/bulk/{carBulkId})
        postCarBulkAdmin: build.mutation({
            query: ({ carBulkId }) => ({
                url: `/api/admin/car/v1/bulk/${carBulkId}`,
                method: "post",
                headers: { token: true },
            }),
        }),

        deleteCarAdmin: build.mutation({
            query: (carId) => ({
                url: `/api/admin/car/v1/${carId}`,
                method: "delete",
                headers: { token: true },
            }),
        }),
    }),
});

export const {
    usePostCarAdminMutation,
    usePutCarAdminMutation,
    useLazySearchCarAdminQuery,
    useLazySearchCarByNumberAdminQuery,
    useGetAllCarsAdminQuery,
    useGetCarByIdAdminQuery,
    useLazyGetCarByIdAdminQuery,
    usePostCarBulkFileAdminMutation,
    usePostCarBulkAdminMutation,
    useDeleteCarAdminMutation,
} = adminCarApi;
